module.exports = __webpack_public_path__ + "img/source05_05.11357cb4.png";